var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9924 5H6.00247C5.15088 5 4.689 5.99649 5.23941 6.64632L9.05224 11.1479C9.66415 11.8703 9.99997 12.7864 9.99997 13.7332V17.9978C9.99997 18.7271 10.7554 19.2111 11.4179 18.9063L13.4179 17.9863C13.7726 17.8231 14 17.4683 14 17.0778V13.7325C14 12.7866 14.3352 11.8712 14.9462 11.149L18.7559 6.64587C19.3057 5.99594 18.8437 5 17.9924 5ZM6.00247 3H17.9924C20.5464 3 21.9323 5.98782 20.2827 7.93762L16.4731 12.4408C16.1676 12.8019 16 13.2595 16 13.7325V17.0778C16 18.2493 15.318 19.3137 14.2537 19.8033L12.2537 20.7233C10.2662 21.6376 7.99997 20.1855 7.99997 17.9978V13.7332C7.99997 13.2598 7.83206 12.8018 7.5261 12.4405L3.71327 7.93896C2.06207 5.98949 3.4477 3 6.00247 3Z",
    fill: "#E5E9EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.aa98624f1c9cba926414bf23d6fd28da.svg";
export { ForwardRef as ReactComponent };